import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { showApiErrorToast } from '@/utils/errors';
import { createWebUrl, webUrlQueryKeys } from '../api/webUrls.api';
import type { CreateWebUrlPayload } from '../types/webUrl.types';

export function useCreateWebUrl(onSuccess?: () => void) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: CreateWebUrlPayload) => createWebUrl(payload),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: webUrlQueryKeys.all() });
      toast.success('Web URL created successfully');
      onSuccess?.();
    },
    onError: (error) => {
      showApiErrorToast(error, 'Failed to create web URL');
    },
  });
}
